var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticClass:"white--text ma-auto font-weight-black",attrs:{"color":"primary","rounded":"","elevation":"10","min-width":"250px","height":"48px"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }